import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import Image from "next/image";
import Script from "next/script";
import { FC } from "react";
export interface SwiperCardProps {
  title: string;
  subTitle: string;
  color: "marigold" | "primary" | "purple" | "cadet";
  image?: string;
  lottie?: string;
  imageFull?: boolean;
  imageClass?: string;
  mobileImage?: string;
}
const colors = {
  marigold: "bg-marigold-50 bg-pattern-7-marigold border-marigold-750",
  primary: "bg-primary-50 bg-pattern-7-dark border-primary-800",
  purple: "bg-purple-25 bg-pattern-7-dark border-purple-775",
  cadet: "bg-cadet-25 bg-pattern-7-dark border-cadet-850"
};
const SwiperCard: FC<SwiperCardProps> = t0 => {
  const $ = _c(33);
  const {
    title,
    subTitle,
    color,
    image,
    lottie,
    imageFull,
    imageClass,
    mobileImage
  } = t0;
  const bgClass = colors[color];
  let t1;
  if ($[0] !== bgClass) {
    t1 = clsx("w-[280px] h-[288px] m:w-full m:h-full rounded-s flex flex-col border border-opacity-10 overflow-hidden", bgClass);
    $[0] = bgClass;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h4 className="text-body-1 m:text-h1 m:font-serif text-primary-800 mb-xs">{title}</h4>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subTitle) {
    t3 = <p className="text-body-2 text-neutral-425 m:text-h1">{subTitle}</p>;
    $[4] = subTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="text-center px-s m:px-m pt-s m:pt-m mb-s m:mb-2m">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !imageFull;
  let t6;
  if ($[9] !== imageFull || $[10] !== t5) {
    t6 = clsx("relative w-auto h-full flex-1 overflow-hidden mx-s m:mx-m", {
      "m:mb-3xl": t5,
      "m:mb-none": imageFull
    });
    $[9] = imageFull;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== image || $[13] !== imageClass) {
    t7 = image && <Image fill={true} alt="" src={image} className={clsx("hidden m:block", imageClass || "object-contain")} loading="lazy" />;
    $[12] = image;
    $[13] = imageClass;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== mobileImage) {
    t8 = mobileImage && <Image fill={true} alt="" src={mobileImage} className="object-contain m:hidden" loading="lazy" />;
    $[15] = mobileImage;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== lottie) {
    t9 = lottie && <div className="flex justify-center overflow-hidden m:h-full"><dotlottie-player style={{
        width: "75%",
        height: "100%"
      }} src={lottie} background="transparent" speed="1" direction="1" mode="normal" loop={true} autoplay={true} /></div>;
    $[17] = lottie;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className={t6}>{t7}{t8}{t9}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t1 || $[25] !== t10 || $[26] !== t4) {
    t11 = <div className={t1}>{t4}{t10}</div>;
    $[24] = t1;
    $[25] = t10;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== lottie) {
    t12 = lottie && <Script src="https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.mjs" type="module" id="lottie-player" />;
    $[28] = lottie;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
export default SwiperCard;